export default __webpack_public_path__ + "static/media/Logo.25abbc6d.png";